import React from "react"
import { Helmet } from "react-helmet"
import { Container } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import List from "./List"
function PropertyPayment() {
  const BreadcrumbDetails = {
    breadcrumbItem: {
      label: "List",
      link: "/payment/properties/list",
    },
    paths: [
      {
        label: "Payments",
        link: "/payment/properties/list",
      },
      {
        label: "Properties",
        link: "/payment/properties/list",
      },
    ],
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>Payments Properties | Discover Equestrian</title>
      </Helmet>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs breadcrumbDetails={BreadcrumbDetails} />

          <List />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default PropertyPayment
